// extracted by mini-css-extract-plugin
export var checkboxWrapper = "Checkbox-module--checkboxWrapper--8c5e4";
export var inputWrapper = "Checkbox-module--inputWrapper--62cbd";
export var input = "Checkbox-module--input--5ec8a";
export var box = "Checkbox-module--box--73232";
export var innerBox = "Checkbox-module--innerBox--6b143";
export var md = "Checkbox-module--md--a6247";
export var sm = "Checkbox-module--sm--519e9";
export var label = "Checkbox-module--label--d405b";